/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Close_Project_Import_ModalInputs */



/**
* | output |
* | --- |
* | "Close project import modal" |
*
* @param {Close_Project_Import_ModalInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const close_project_import_modal = /** @type {((inputs?: Close_Project_Import_ModalInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Close_Project_Import_ModalInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Fermer la fenêtre d’importation de projet")
	if (locale === "de") return /** @type {LocalizedString} */ ("Projektimport-Modal schließen")
	if (locale === "it") return /** @type {LocalizedString} */ ("Chiudi la finestra modale di importazione del progetto")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Закрыть модальное окно импорта проекта")
	if (locale === "es") return /** @type {LocalizedString} */ ("Cerrar el modal de importación del proyecto")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("关闭项目导入模态框")
	if (locale === "ja") return /** @type {LocalizedString} */ ("プロジェクトのインポートモーダルを閉じる")
	if (locale === "hi") return /** @type {LocalizedString} */ ("प्रोजेक्ट आयात मॉडल बंद करें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Fechar modal de importação de projeto")
	return /** @type {LocalizedString} */ ("Close project import modal")
});